<app-academies-header></app-academies-header>
<section class="body-section">
    <div class="container ">
        <main>
            <div class="col-md-12 user-top-body-header d-flex justify-content-between">
                <div class="left-section">
                    <div class="media">
                        <div class="media-left">
                            <div class="user-image">
                                <img [src]="(profileimage) ? profileimage : '../../../../assets/images/academy_dummy.jpg'" alt="">
                            </div>
                            <div class="media-body">
                                <div class="tag"> <span style="text-transform:capitalize" *ngIf="academyDetails">
                                        {{academyDetails['membershipType']}}</span> </div>
                                <div class="name ">
                                    <h4>{{academyname}}</h4>
                                </div>
                             
                                <div class="col-md-12">
                                    <div class="rating-star">
                                        <ul>
                                            <div class="founded-year"> Founded : {{foundedYear}}
                                            </div>
                                            <!-- <li>
                                                <span>
                                                    <i class="bx bxs-star"></i>
                                                </span>
                                            </li>
                                            <li>
                                                <span>
                                                    <i class="bx bxs-star"></i>
                                                </span>
                                            </li>
                                            <li>
                                                <span>
                                                    <i class="bx bxs-star"></i>
                                                </span>
                                            </li>
                                            <li>
                                                <span>
                                                    <i class="bx bxs-star"></i>
                                                </span>
                                            </li>
                                            <li>
                                                <span>
                                                    <i class="bx bx-star"></i>
                                                </span>
                                            </li>
                                            <div class="count">4.0</div> -->
                                        </ul>
                                    </div>
                                    <p class="id d-flex icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z">
                                            </path>
                                        </svg> <span *ngIf="academyDetails">{{academyDetails.address}},
                                            {{academyDetails.cityname}} {{academyDetails.statename}}
                                            {{academyDetails.countryname}} {{academyDetails.zipcode}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="edite-side">
                    <div class="media-right">
                        <div class="profiles-buttons">
                            <div class="edite-profile-section">
                                <a class="btn" (click)="onclickedit()">
                                    <i class='bx bx-pencil'></i> Edit Details </a>
                            </div>
                            <div class="edite-profile-section gallery">
                                <a href="academies-profile-slider.html" class="btn"
                                    routerLink="academies-profile-slider">
                                    <i class='bx bx-image'></i> Edit <span class="mobile-span-none">Academy</span> Gallery</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="right-side-section"><div class="box spending-box"><div class="pie-chart"><canvas id="myChart2" height="180px" width="180px"></canvas><div class="overall-spending"><h4>skill
                                  </h4><span>20.4</span></div></div></div></div> -->
            </div>
            <!-- academy KYC Not required for now -->
            <!-- <div class=" col-md-12 bottom-container tablesections KYC-notice">
                <div class="header-container box w-100">
                    <div class=" col-md-12 bottom-container tablesections KYC-notices">
                        <div class="media">
                            <div class="media-left" *ngIf="!kycDone">



                                <div class="icon" *ngIf="!kycDone">
                                    <i class='bx bx-paperclip'></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h2 *ngIf="kycDone" class="mb-3">KYC Info</h2>
                                <h2 *ngIf="!kycDone">KYC Incomplete</h2>


                                <p *ngIf="!kycDone"> To ensure the security and compliance of our platform, we
                                    kindly
                                    request you to complete the Know Your Customer (KYC) process by uploading the
                                    required
                                    documents.

                                </p>
                            </div>
                            <div class="media-right">
                                <button pButton routerLink="../kyc" *ngIf="!kycDone">Update KYC</button>
                                <div class="media-right"  *ngIf="kycDone">
                                    <button routerLink="../view-kyc">view KYC</button>
                                    </div>
                                    <div class="media-right"  *ngIf="kycDone && kycVerificationInComplete">
                                        <button routerLink="../kyc">Edit KYC</button>
                                        </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div> -->
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">WOW FACTOR/ACHIEVEMENTS </h3>
                    </div>
                    <div class="col-md-12">
                        <div class="swiper high-light-slider">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="court_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let highlight of highlightlist " class="swiper-slide"
                                    style="width: 292.25px;margin-right: 5px;">
                                    <div class="heiglght-div card">
                                        <div class="image">
                                            <img src="{{highlight.image}}" alt="" class="w-100">
                                        </div>
                                        <div class="headigns">
                                            <h4>{{highlight.heading}}</h4>
                                        </div>
                                        <p class="subhead">{{highlight.descriptions}}</p>
                                    </div>
                                </div>
                            </swiper>
                        </div>
                        <!-- <div class="swiper-button-next"></div><div class="swiper-button-prev"></div><div class="swiper-pagination"></div> -->
                    </div>
                    <div class="Show-more-btn text-center w-100">
                        <a routerLink="highlights">
                            <button>Add / Edit</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">TOP PLAYERS </h3>
                        <div class="year-selector"></div>
                    </div>
                    <div class="col-md-12 top-player">
                        <div class="swiper players">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="court_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let player of playerlist " class="swiper-slide">
                                    <img src="{{player.image}}" alt="" class="w-100">
                                    <div class="main-div">
                                        <h2>{{player.playerName}}</h2>
                                        <div class="price-details ">
                                            <div class="price-per">
                                                <div class="text">
                                                    {{player.descriptions}}
                                                </div>
                                                <div class="location list">
                                                    <span>
                                                        <i class="bi bi-geo-alt"></i>
                                                    </span> Mumbai
                                                </div>
                                                <div class="social-links ">
                                                    <a *ngIf="player.youtubeUrl" href="{{player.youtubeUrl}}"
                                                        class="youtube"><i class="bx bxl-youtube"></i></a>
                                                    <a *ngIf="player.fbUrl" href="{{player.fbUrl}}" class="facebook"><i
                                                            class="bx bxl-facebook"></i></a>
                                                    <a *ngIf="player.instagramUrl" href="{{player.instagramUrl}}"
                                                        class="instagram"><i class="bx bxl-instagram"></i></a>
                                                    <a *ngIf="player.skypeUrl" href="{{player.skypeUrl}}"
                                                        class="google-plus"><i class="bx bxl-skype"></i></a>
                                                    <a *ngIf="player.linkedinUrl" href="{{player.linkedinUrl}}"
                                                        class="linkedin"><i class="bx bxl-linkedin"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper>
                        </div>
                        <!-- Add Pagination -->
                        <!-- <div class="swiper-pagination"></div> -->
                    </div>
                    <div class="Show-more-btn text-center w-100">
                        <a routerLink="top-players">
                            <button>Add / Edit</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">COURTS </h3>
                        <div class="year-selector"></div>
                    </div>
                    <div class="col-md-12 top-player courts-type">
                        <div class="swiper Courts">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="courts_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let court of courtlist " class="swiper-slide">
                                    <img src="{{court.image}}" alt="" class="w-100">
                                    <div class="main-div">
                                        <h2>Surface: {{court.courtType}}</h2>
                                    </div>
                                </div>
                            </swiper>
                        </div>
                        <!-- Add Pagination -->
                        <!-- <div class="swiper-pagination"></div> -->
                    </div>
                    <div class="Show-more-btn text-center w-100">
                        <a routerLink="courts">
                            <button>Add / Edit</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">BRANCHES </h3>
                        <div class="year-selector"></div>
                    </div>
                    <div class="col-md-12 top-player">
                        <div class="swiper branch-list-div  branch-list-divslider main">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="courts_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let branch of branchlist" class="swiper-slide">
                                    <div class="col-sm-12 branch-list-div ">
                                        <div class="media">
                                            <div class="media-left">
                                                <img src="{{branch.image}}" alt="" class="w-100">
                                            </div>
                                            <div class="media-body">
                                                <div class="Name ">
                                                    <h4>{{branch.name}}</h4>
                                                </div>
                                                <div class="contact-us-buttons">
                                                    <ul>
                                                        <li *ngIf="branch.address">
                                                            <a href="#">
                                                                <button>
                                                                    <div class="location list">
                                                                        <span>
                                                                            <i class="bi bi-geo-alt"></i>
                                                                        </span>
                                                                        {{branch.address}}
                                                                    </div>
                                                                </button>
                                                            </a>
                                                        </li>
                                                        <li *ngIf="branch.mobileNumber">
                                                            <a href="tel:{{branch.mobileNumber}}">
                                                                <button class="Call">
                                                                    <span>
                                                                        <i class="bx bx-phone-call"></i>
                                                                    </span>
                                                                    {{branch.mobileNumber}}
                                                                </button>
                                                            </a>
                                                        </li>
                                                        <li *ngIf="branch.email">
                                                            <a href="mailto:{{branch.email}}">
                                                                <button class="email">
                                                                    <span>
                                                                        <i class="bx bx-envelope"></i>
                                                                    </span>
                                                                    {{branch.email}}
                                                                </button>
                                                            </a>
                                                        </li>
                                                        <li *ngIf="branch.webUrl">
                                                            <a style="cursor: default;">
                                                                <button class="email">
                                                                    <span>
                                                                        <i class="bx bx-globe"></i>
                                                                    </span>
                                                                    {{branch.webUrl}}
                                                                </button>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper>
                        </div>
                        <!-- <div class="swiper-button-next"></div><div class="swiper-button-prev"></div><div class="swiper-pagination"></div> -->
                    </div>
                    <div class="Show-more-btn text-center w-100">
                        <a routerLink="branches">
                            <button>Add / Edit</button>
                        </a>
                    </div>
                </div>
            </div>




            <div class=" col-md-12 bottom-container tablesections SliderImages-div">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">ACADEMY GALLERY</h3>
                        <div class="year-selector"></div>
                    </div>
                    <div class="col-md-12 coatch">
                        <div class="coach-list">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="sliders_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let slider of sliderImages " class="swiper-slide">
                                    <div class="image">
                                        <img src="{{slider.slider_image_src}}" alt="">
                                    </div>

                                </div>
                            </swiper>
                        </div>
                        <div class="Show-more-btn text-center w-100">
                            <a routerLink="academies-profile-slider">
                                <button>Add / Edit</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">COACHES </h3>
                        <div class="year-selector"></div>
                    </div>
                    <div class="col-md-12 coatch">
                        <div class="coach-list">
                            <swiper class="swiper-wrapper" fxFlex="auto" [config]="court_config" [disabled]="disabled"
                                (indexChange)="onIndexChange($event)"
                                (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                <div *ngFor="let coach of coachData " class="swiper-slide">
                                    <div class="image">
                                        <img src="{{coach.image}}" alt="">
                                    </div>
                                    <div class="header-heading">
                                        <h4> {{coach.coachName}}</h4>
                                        <h6>{{coach.coachRole}}</h6>
                                    </div>
                                </div>
                            </swiper>
                        </div>
                        <div class="Show-more-btn text-center w-100">
                            <a routerLink="coaches">
                                <button>Add / Edit</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<p-dialog header="Reason of Rejection" [(visible)]="rejectKycReasonView" [modal]="true" [style]="{ width: '500px' }" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" 
    [draggable]="false" [resizable]="false" class="modal-payment-select">
   <div>
    {{viewReason}}
   </div>
</p-dialog>